import { defineSettingMap } from '@juvare/platform-sdk-react/backend/features/editable-settings/shared';
import { getAccountImportSettingFormConfig } from '../utils/getAccountImportSettingFormConfig';
export const defaultAccountImportFieldTypeValues = [
    {
        value: 'accountStatus',
        label: 'Account Status',
    },
    {
        value: 'systemRole',
        label: 'System Role',
    },
    {
        value: 'accountEmail',
        label: 'Login Email',
    },
    {
        value: 'boolean',
        label: 'Yes/No',
    },
    {
        value: 'countyName',
        label: 'County',
    },
    {
        value: 'date',
        label: 'Date',
    },
    {
        value: 'dateTime',
        label: 'Date and Time',
    },
    {
        value: 'emailArray',
        label: 'Email',
    },
    {
        value: 'stringArray',
        label: 'Multiselect Text Values',
    },
    {
        value: 'number',
        label: 'Numeric Value',
    },
    {
        value: 'organizationArray',
        label: 'Organization',
    },
    {
        value: 'pagerNumberArray',
        label: 'Pager Number',
    },
    {
        value: 'phoneNumberFaxArray',
        label: 'Phone Number Fax',
    },
    {
        value: 'phoneNumberTextArray',
        label: 'Phone Number Text',
    },
    {
        value: 'phoneNumberVoiceArray',
        label: 'Phone Number Voice',
    },
    {
        value: 'stateCode',
        label: 'State',
    },
    {
        value: 'stateAndTerritoryCode',
        label: 'State and Territory',
    },
    {
        value: 'string',
        label: 'Text Value',
    },
];
/**
 * Account import columns which don't have `destination` property
 */
export const defaultImportSettingsDestinationFieldExclusions = [
    'accountEmail',
    'accountStatus',
    'organizationArray',
    'systemRole',
];
/**
 * Account import columns which have `length` property
 */
export const defaultImportSettingsLengthFieldInclusions = [
    'string',
    'boolean',
    'number',
    'date',
    'accountEmail',
    'accountStatus',
];
export const defaultAccountImportValues = [
    {
        headerName: 'LAST_NAME',
        exampleValue: 'Doe',
        type: 'string',
        destination: 'lastName',
        required: true,
    },
    {
        headerName: 'FIRST_NAME',
        exampleValue: 'John',
        type: 'string',
        destination: 'firstName',
        required: true,
    },
    {
        headerName: 'EMAIL',
        exampleValue: 'JohnDoe@example.com',
        type: 'accountEmail',
        required: true,
    },
    {
        headerName: 'SYSTEM_ROLE',
        exampleValue: 'User',
        type: 'systemRole',
    },
    {
        headerName: 'STATUS',
        exampleValue: 'active',
        type: 'accountStatus',
        required: true,
    },
    {
        headerName: 'ADDRESS_1',
        exampleValue: '217 Ford House Office Building',
        type: 'string',
        destination: 'address.addressLine1',
    },
    {
        headerName: 'ADDRESS_2',
        exampleValue: '',
        type: 'string',
        destination: 'address.addressLine2',
    },
    {
        headerName: 'CITY',
        exampleValue: 'Washington',
        type: 'string',
        destination: 'address.city',
    },
    {
        headerName: 'STATE',
        exampleValue: 'WA',
        type: 'stateCode',
        destination: 'address.state',
    },
    {
        headerName: 'COUNTY_NAME',
        exampleValue: 'Adams County',
        type: 'countyName',
        destination: 'address.countyName',
    },
    {
        headerName: 'POSTAL_CODE',
        exampleValue: '20024',
        type: 'string',
        destination: 'address.postalCode',
    },
    {
        headerName: 'CONTACT_EMAIL',
        exampleValue: 'JohnDoe@example.com;JaneDoe@example.com',
        type: 'emailArray',
        destination: 'contactEmails',
    },
    {
        headerName: 'CONTACT_PHONE_NUMBER_TEXT',
        exampleValue: '+1XXXXXXXXXX;+1XXXXXXXXXX',
        type: 'phoneNumberTextArray',
        destination: 'contactPhoneNumbers',
    },
    {
        headerName: 'CONTACT_PHONE_NUMBER_VOICE',
        exampleValue: '+1XXXXXXXXXX;+1XXXXXXXXXX',
        type: 'phoneNumberVoiceArray',
        destination: 'contactPhoneNumbers',
    },
    {
        headerName: 'CONTACT_PHONE_NUMBER_FAX',
        exampleValue: '+1XXXXXXXXXX;+1XXXXXXXXXX',
        type: 'phoneNumberFaxArray',
        destination: 'contactPhoneNumbers',
    },
    {
        headerName: 'PAGERS',
        exampleValue: '1234567890@example.com',
        type: 'pagerNumberArray',
        destination: 'pagerNumbers',
    },
    {
        headerName: 'ORGANIZATION_PATH',
        exampleValue: 'Parent Organization/Child Organization',
        type: 'organizationArray',
    },
];
export const accountImport = defineSettingMap({
    /**
     * @public
     * */
    accountImport: {
        type: 'json',
        description: 'Account Import Fields',
        group: 'system-admin',
        defaultValue: defaultAccountImportValues,
        form: getAccountImportSettingFormConfig(defaultAccountImportFieldTypeValues, defaultImportSettingsDestinationFieldExclusions, defaultImportSettingsLengthFieldInclusions),
    },
});
